// Cifras a costo que el servidor puede mandar en null (SEG-4, 1 oct 2026).
//
// Desde ese día el servidor no le entrega el costo promedio —ni ninguna
// cifra calculada con él— a quien no tiene el permiso «Ver el valor a
// costo» (`costo`). El campo sigue llegando, en null. Aquí está la única
// forma de pintarlo: un «—», nunca un «$0.00» que parezca un dato.

export const SIN_PERMISO_COSTO =
  'Las cifras a costo se ven con el permiso «Ver el valor a costo». Lo concede quien administra tu empresa, en Personal → la ficha de la persona.';

// La misma regla, para una tarjeta pequeña.
export const SIN_PERMISO_COSTO_CORTO = 'Se ve con el permiso «Ver el valor a costo».';

export function hayCosto(v) {
  return v !== null && v !== undefined;
}

// `formato` es un Intl.NumberFormat de moneda.
export function aCosto(formato, v) {
  return hayCosto(v) ? formato.format(v) : '—';
}

// Para las columnas que se exportan: vacío, no cero.
export function numeroDeCosto(v) {
  return hayCosto(v) ? Number(v) : '';
}
